import React from "react"
import styles from "./ProfileSection.module.css"

const Eduaction = () => (
  <div className={styles.table_wrapper}>
    <table className={styles.list}>
      <tdboy>
        <tr>
          <td>1995 он</td>
          <td>
            ОХУ-ын Екатеринбург хотод УГТУ (одоогийн нэршил нь УРФУ)-г Цахилгаан
            систем шугам сүлжээний инженер мэргэжлээр магисрт зэрэгтэй төгссөн.
            <a
              href="https://urfu.ru/ru/"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              {" "}
              https://urfu.ru/ru/{" "}
            </a>
          </td>
        </tr>
        <tr>
          <td>2013 он</td>
          <td>
            Хүмүүнлэгийн Ухааны Их сургуулийн Хэл Соёлын сургуулийг англи хэлний
            орчуулагч мэргэжлээр баклавр зэрэгтэй төгссөн.
            <a
              href="https://www.humanities.mn/"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              {" "}
              https://www.humanities.mn/{" "}
            </a>
          </td>
        </tr>
      </tdboy>
    </table>
  </div>
)
const WorkExperience = () => (
  <div className={styles.table_wrapper}>
    <table className={styles.list}>
      <tbody>
        <tr>
          <td>2020 оноос</td>
          <td> ISO 50001:2018 стандартын Тэргүүлэх хэрэгжүүлэгч</td>
        </tr>
        <tr>
          <td>2020 оноос</td>
          <td>Эрчим хүчний аудитор</td>
        </tr>
        <tr>
          <td>2017 – 2018</td>
          <td>НҮБ-ын “Барилгын НАМА” төсөлд Зөвлөх</td>
        </tr>
        <tr>
          <td>2014 – 2019 </td>
          <td>ЭХЭЗХ ТӨҮГ-т Эрдэм шинжилгээний ажилтан</td>
        </tr>
        <tr>
          <td>2010 – 2014</td>
          <td>Эрчим сүлжээ ХХК-нд Ерөнхий диспетчер</td>
        </tr>
        <tr>
          <td>1997 – 2010 </td>
          <td>ЦДҮС ТӨХК-нд Диспетчер инженер</td>
        </tr>
      </tbody>
    </table>
  </div>
)
const BackgroundSkill = () => (
  <table className={styles.list}>
    <tbody>
      <tr>
        <td>2021 он </td>
        <td>Мэргэшсэн төсөвчин (БТХ)</td>
      </tr>
      <tr>
        <td>2020 он </td>
        <td>ISO 19011: 2018 Дотоод аудитор (Обсерв ЗҮБ)</td>
      </tr>
      <tr>
        <td>2019 он </td>
        <td>ISO 50001:2018 Тэргүүлэх хэрэгжүүлэгч (PECB ОУБ)</td>
      </tr>
      <tr>
        <td>2018 он </td>
        <td>Үйлдвэрлэлийн эрчим хүчний хэмнэлтийн зөвлөх (ЕСБХБ)</td>
      </tr>
      <tr>
        <td>2017 он </td>
        <td>Барилгын эрчим хүчний аудитор (ЭХЗХ)</td>
      </tr>
      <tr>
        <td>2016 он </td>
        <td>Эрчим хүчний хэмнэлтийн сургагч багш (ЭХЗХ)</td>
      </tr>
      <tr>
        <td>2016 он </td>
        <td> Мэргэшсэн инженер (БХТ)</td>
      </tr>
      <tr>
        <td>2015 он </td>
        <td>ISO 9001:2015 Хэрэгжүүлэгч (EEC ОУБ)</td>
      </tr>
    </tbody>
  </table>
)
const Fellowship = () => (
  <table className={styles.list}>
    <tbody>
      <tr>
        <td>2023 он</td>
        <td>
          AEE
          <a
            href="https://www.aeecenter.org/"
            target="_blank"
            rel="noreferrer"
            F
            className={styles.link}
          >
            {" "}
            https://www.aeecenter.org/
          </a>
        </td>
      </tr>
      <tr>
        <td>2019 он</td>
        <td>
          PECB-ийн гишүүн{" "}
          <a
            href="https://www.pecb.org/"
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            {" "}
            https://pecb.com/{" "}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
)

export default function ProfileSection() {
  return (
    <div className={styles.container}>
      <div className={styles.layout}>
        <div className={styles.wrapper}>
          <div className={styles.grid}>
            <div className={styles.picture}>
              <img
                src="https://i.imgur.com/uPZ89Y3.jpeg"
                alt="pfpzurag"
                className={styles.profile_image}
              />
            </div>
            <div className={styles.text}>
              <h1>Д. Баасансүрэн</h1>
              <p>Эрчим хүчний салбарт 23 жил ажиллаж байна.</p>
              <ul>
                <li>Эрчим хүчний аудитор</li>
                <li>ISO 50001:2018 стандартын тэргүүлэх хэрэгжүүлэгч</li>
                <li>Мэргэшсэн инженер</li>
                <li>Мэргэшсэн төсөвчин</li>
              </ul>
            </div>
            {/* bolovsrol */}
          </div>
          <div className={styles.edu}>
            <h1>
              {" "}
              <span className="underline">Боловсрол</span>
            </h1>
            <div>
              <Eduaction />
            </div>
            <div>
              <h1>
                <span className="underline">Мэргэшил</span>
              </h1>
              <BackgroundSkill />
            </div>
            <div>
              <h1>
                <span className="underline">Ажлын туршлага</span>
              </h1>
              <WorkExperience />
            </div>

            <div>
              <h1>
                <span className="underline">Гишүүнчлэл</span>
              </h1>
              <Fellowship />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
